
import { createSlice } from "@reduxjs/toolkit";

const webStorySlice = createSlice({
    name: "webStoryReducer",
    initialState: {
        webStoryFilterEntityNameLoading: null,
        webStoryFilterEntityNameData: null,
        webStoryFilterEntityNameError: null,

        webStoryFilterEntityTypeLoading: null,
        webStoryFilterEntityTypeData: null,
        webStoryFilterEntityTypeError: null,
        
        webStoryFilterWebstoryTitleLoading: null,
        webStoryFilterWebstoryTitleData: null,
        webStoryFilterWebstoryTitleError: null,

        webStoryListLoading: null,
        webStoryListData: null,
        webStoryListError: null,

        webStoryAddEditLoading: null,
        webStoryAddEditData: null,
        webStoryAddEditError: null,

        putwebStoryAddEditLoading: null,
        putwebStoryAddEditData: null, 
        putwebStoryAddEditError: null, 

        getEntityFilterLoading: null,
        getEntityFilterData: null,
        getEntityFilterError: null, 

        postEntityFilterLoading: null, 
        postEntityFilterData: null, 
        postEntityFilterError: null,

        deleteEntityFilterLoading: null,
        deleteEntityFilterData: null, 
        deleteEntityFilterError: null,

        webStoryFilterLoading: null,
        webStoryFilterData: null,
        webStoryFilterError: null,
    },
    reducers: {
        getWebStoryFilterEntityNameLoading(state, action) {
            return {
                ...state,
                webStoryFilterEntityNameLoading: true,
            };
        },
        getWebStoryFilterEntityNameSuccess(state, action) {
            return {
                ...state,
                webStoryFilterEntityNameLoading: false,
                webStoryFilterEntityNameData: action.payload,
            };
        },
        getWebStoryFilterEntityNameFailure(state, action) {
            return {
                ...state,
                webStoryFilterEntityNameLoading: false,
                webStoryFilterEntityNameError: action.payload,
            };
        },
        getWebStoryFilterEntityTypeLoading(state, action) {
            return {
                ...state,
                webStoryFilterEntityTypeLoading: true,
            };
        },
        getWebStoryFilterEntityTypeSuccess(state, action) {
            return {
                ...state,
                webStoryFilterEntityTypeLoading: false,
                webStoryFilterEntityTypeData: action.payload,
            };
        },
        getWebStoryFilterEntityTypeFailure(state, action) {
            return {
                ...state,
                webStoryFilterEntityTypeLoading: false,
                webStoryFilterEntityTypeError: action.payload,
            };
        },
        getWebStoryFilterWebstoryTitleLoading(state, action) {
            return {
                ...state,
                webStoryFilterWebstoryTitleLoading: true,
            };
        },
        getWebStoryFilterWebstoryTitleSuccess(state, action) {
            return {
                ...state,
                webStoryFilterWebstoryTitleLoading: false,
                webStoryFilterWebstoryTitleData: action.payload,
            };
        },
        getWebStoryFilterWebstoryTitleFailure(state, action) {
            return {
                ...state,
                webStoryFilterWebstoryTitleLoading: false,
                webStoryFilterWebstoryTitleError: action.payload,
            };
        },
        getWebStoryListLoading(state , action){
            return{
                ...state,
                webStoryListLoading : true,
            };
        },
        getWebStoryListSuccess(state , action){
            return{
                ...state,
                webStoryListLoading: false,
                webStoryListData: action.payload,
            };
        },
        getWebStoryListFailure(state,action){
            return {
                ...state,
                webStoryListLoading : false,
                webStoryFilterError: action.payload,
            };
        },

        getWebStoryAddEditLoading(state , action){
            return{
                ...state,
                webStoryAddEditLoading : true,
            };
        },
        getWebStoryAddEditSuccess(state , action){
            return{
                ...state,
                webStoryAddEditLoading: false,
                webStoryAddEditData: action.payload,
            };
        },
        getWebStoryAddEditFailure(state,action){
            return {
                ...state,
                webStoryAddEditLoading : false,
                webStoryAddEditError: action.payload,
            };
        },
        putWebStoryAddEditLoading(state, action){
            return{
                ...state,
                putwebStoryAddEditLoading: true,
            };
        },
        putWebStoryAddEditSuccess(state , action){
            return{
                ...state,
                putwebStoryAddEditLoading: false,
                putwebStoryAddEditData: action.payload,
                message: "Data Saved Successfully",
            };
        },
        putWebStoryAddEditFailure(state , action){
            return {
                ...state, 
                putwebStoryAddEditError: false,
                putwebStoryAddEditLoading: action.payload,
                message: "Something went wrong",
            }
        },
        getWebStoryFilterLoading(state , action){
            return{
                ...state,
                webStoryFilterLoading: true,
            };
        },
        getWebStoryFilterSuccess(state , action){
            return{
                ...state,
                webStoryFilterLoading: false,
                webStoryFilterData:action.payload,
            };
        },
        getWebStoryFilterFailure(state, action){
            return{
                ...state,
                webStoryFilterLoading: false,
                webStoryFilterError: action.payload,
            };
        },
        getWebStoryEntityFilterLoading(state , action){
            return{
                ...state,
                getEntityFilterLoading: true,
            };
        },
        getWebStoryEntityFilterSuccess(state , action){
            return{
                ...state,
                getEntityFilterLoading: false,
                getEntityFilterData:action.payload,
            };
        },
        getWebStoryEntityFilterFailure(state, action){
            return{
                ...state,
                getEntityFilterLoading: false,
                getEntityFilterError: action.payload,
            };
        },
        postWebStoryEntityFilterLoading(state, action){
            return{
                ...state,
                postEntityFilterLoading: true,
            };
        },
        postWebStoryEntityFilterSuccess(state , action){
            return{
                ...state,
                postEntityFilterLoading: false, 
                postEntityFilterData: action.payload,
            };
        },
        postWebStoryEntityFilterFailure(state , action){
            return{
                ...state, 
                postEntityFilterLoading: false,
                postEntityFilterError: action.payload,
            };
        },
        deleteWebStoryEntityFilterLoading(state , action){
            return{
                ...state,
                deleteEntityFilterLoading: true,
            };
        },
        deleteWebStoryEntityFilterSuccess(state , action){
            return{
                ...state,
                deleteEntityFilterLoading: false,
                deleteEntityFilterData: action.payload,
            };
        },
        deleteWebStoryEntityFilterFailure(state,action){
            return{
                ...state,
                deleteEntityFilterLoading: false,
                deleteEntityFilterError: action.payload,
            };
        },
    },
});
export const {
    getWebStoryFilterEntityNameLoading,
    getWebStoryFilterEntityNameSuccess,
    getWebStoryFilterEntityNameFailure,

    getWebStoryFilterEntityTypeLoading,
    getWebStoryFilterEntityTypeSuccess,
    getWebStoryFilterEntityTypeFailure,

    getWebStoryFilterWebstoryTitleLoading,
    getWebStoryFilterWebstoryTitleSuccess,
    getWebStoryFilterWebstoryTitleFailure,

    getWebStoryListLoading,
    getWebStoryListSuccess,
    getWebStoryListFailure,

    getWebStoryAddEditLoading,
    getWebStoryAddEditSuccess,
    getWebStoryAddEditFailure,

    putWebStoryAddEditLoading,
    putWebStoryAddEditSuccess,
    putWebStoryAddEditFailure,

    getWebStoryEntityFilterLoading,
    getWebStoryEntityFilterSuccess,
    getWebStoryEntityFilterFailure,

    postWebStoryEntityFilterLoading,
    postWebStoryEntityFilterSuccess,
    postWebStoryEntityFilterFailure,

    deleteWebStoryEntityFilterLoading,
    deleteWebStoryEntityFilterSuccess,
    deleteWebStoryEntityFilterFailure,

    getWebStoryFilterLoading,
    getWebStoryFilterSuccess,
    getWebStoryFilterFailure,



} = webStorySlice.actions;
       
export default webStorySlice.reducer;